import React, { FunctionComponent } from 'react';
import { KompisImage } from '@inter-ikea-kompis/react-components';
import { Header, HeaderContainer } from './CheckoutHeaderStyle';

const CheckoutHeader: FunctionComponent = () => {
	return (
		<Header>
			<HeaderContainer>
				<a href={'https://www.ikea.com/'} target={'_blank'}>
					<KompisImage
						src="/addon-app/sofas/content/s3/1.0.2-186-g46a769e/logo/ikea-logo.f7d9229f806b59ec64cb.svg"
						alt={'IKEA'}
						// @ts-expect-error Kompis elemenets support style but it isn't exposed
						style={{
							display: 'flex',
							alignItems: 'center',
						}}
					></KompisImage>
				</a>
			</HeaderContainer>
		</Header>
	);
};

export default CheckoutHeader;
